import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'ld-input-base',
  templateUrl: './ld-input-base.template.html'
})
export class InputBaseComponent {
  @Input() labelPrefix: string;
  @Input() label: string;
  @Input() title: string = '';
  @Input() hasValidationError: boolean = false;
  @Input() titleClass: string = '';

  @HostBinding('class') _class = 'd-block';

  constructor() {
  }
}
